import {
  Bounds,
  Environment,
  Float,
  Mask,
  OrbitControls,
  PivotControls,
  RoundedBox,
  useGLTF,
  useMask,
} from '@react-three/drei';
import { Canvas, GroupProps, MeshProps } from '@react-three/fiber';
import * as React from 'react';
import { DirectionalLight } from 'three/src/lights/DirectionalLight';
import Area from './Area';
import glbReactTransformed from './react-transformed.glb';

function Box(props: React.ComponentProps<typeof RoundedBox> & { color: string }) {
  const { color, ...rest } = props;
  return (
    <RoundedBox {...rest}>
      <meshPhongMaterial color={color} />
    </RoundedBox>
  );
}

function Atom(props: MeshProps) {
  const stencil = useMask(1);
  const { nodes } = useGLTF(glbReactTransformed) as any;
  console.log('Atom', { stencil });
  return (
    <mesh castShadow receiveShadow geometry={nodes.atom.geometry} {...props} dispose={null}>
      <meshPhongMaterial color="#33BBFF" {...stencil} />
    </mesh>
  );
}

const Frame = (props: MeshProps) => (
  <mesh {...props}>
    <ringGeometry args={[0.785, 0.85, 64]} />
    <meshPhongMaterial color="black" />
  </mesh>
);

const CircularMask = (props: GroupProps) => (
  <group {...props}>
    {/* <PivotControls offset={[0, 0, 1]} activeAxes={[true, true, false]} disableRotations depthTest={false}> */}
    <Frame position={[0, 0, 1]} />
    <Mask id={1} position={[0, 0, 0.95]}>
      <circleGeometry args={[0.8, 64]} />
      <meshBasicMaterial />
    </Mask>
    {/* </PivotControls> */}
  </group>
);

export type Props = {};

function App04(props: Props) {
  const {} = props;
  return (
    <Area>
      <Canvas camera={{ position: [0, 3, 10], fov: 50 }} gl={{ stencil: true }}>
        <directionalLight position={[1, 2, 1.5]} intensity={0.5} castShadow />
        <hemisphereLight intensity={1.5} groundColor="red" />
        <React.Suspense>
          <CircularMask position={[-2, 0, 0]} />
          <CircularMask />
          <CircularMask position={[2, 0, 0]} />
          <Float floatIntensity={4} rotationIntensity={0} speed={4}>
            <Atom scale={1.5} />
          </Float>
          <Box color="#EAC435" args={[1, 5, 1]} rotation-y={Math.PI / 4} position={[0, 0, -2]} />
          <Box color="#03CEA4" args={[2, 2, 2]} position={[-2, 0, -2]} />
          <Box color="#FB4D3D" args={[2, 2, 2]} position={[2, 0, -2]} />
        </React.Suspense>
        <OrbitControls makeDefault />
        <axesHelper />
        <gridHelper />
      </Canvas>
    </Area>
  );
}

export default React.memo(App04);
